export default __webpack_public_path__ + "static/media/step-one.2ee28ade.png";